import { useContext } from 'react';
import { Menubar } from 'primereact/menubar';
import logoMenu from '../images/logo192.png'
import '../multilingual/config.js';
import { useTranslation } from 'react-i18next';
import LanguageSwitcherComponent from './LanguageSwitcherComponent.jsx';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../Contexts/AuthContext.jsx';
import { logoutService } from '../Service/UserService.jsx';
import { Avatar } from 'primereact/avatar';

function MenuBarComponent() {
    const {userAuth, setUserAuth} = useContext(AuthContext);

    const { t } = useTranslation('landing_page_home');
    const navigate = useNavigate()

    const items = !userAuth?.user ? 
    [
        {
            label: t('menu_home'),
            command: ()=>navigate('/'),
        },
        {
            label: t('menu_about'),
            command: ()=>navigate('/'),
        },
        {
            label: t('menu_services'),
            command: ()=>navigate('/'),
        },
        {
            label: t('menu_how_works'),
            command: ()=>navigate('/'),
        },
    ] :
    [
        {
            label: t('menu_home'),
            command: ()=>navigate('/app/user_home'),
        },
        {
            label: t('menu_logout'),
            command: ()=>{
                logoutService(userAuth?.user?.access_key).then(res=>{
                    if (res){
                        setUserAuth(null)
                        navigate('/')
                    }
                })
            },
        },
    ];

    const start = <div onClick={()=>navigate('/')}><img alt="logo" src={logoMenu} height="60" className="mx-2 md:mx-4 my-1 md:my-2"></img></div>;
    const end = (
        <div className="flex justify-content-end align-items-end gap-4 mx-2 md:mx-4 my-1 md:my-2">
            {userAuth?.user && <div className='flex flex-column align-items-center'>
                <Avatar className='bg-green-200 font-bold' label={userAuth?.user?.name && userAuth?.user?.name[0]?.toUpperCase()} shape='circle' size='normal' />
                <span className='text-sm'>{userAuth?.user?.name ? userAuth?.user?.name.split(' ').length > 0 ? userAuth?.user?.name.split(' ')[0] : userAuth?.user?.name : userAuth?.user?.email }</span>
            </div>}
            <LanguageSwitcherComponent />
        </div>
    );

    return (
        <div className="card">
            <Menubar model={items} start={start} end={end} />
        </div>
    )
}
       
export default MenuBarComponent